import client from "src/api/client";
import type { NestUseCase } from "src/api/interfaces/nest";
import { useCountrySelection } from "src/components/Contexts/CountrySelectionContext";
import { useNest } from "src/components/Contexts/NestContext";
import { useAsyncFetcher } from "./useAsyncFetcher";

export const useNestUseCaseFetcher = () => {
  const { selectedCountry } = useCountrySelection();
  const { partnerCode } = useNest();

  return useAsyncFetcher<NestUseCase[]>(
    () =>
      client.getNestUseCases({
        countryCode: selectedCountry?.countryCode,
        partnerCode: partnerCode ?? undefined,
      }),
    [],
    [selectedCountry?.countryCode, partnerCode],
    !!selectedCountry?.countryCode
  );
};
